import styled from "styled-components";

const ContentContainer = styled.div<{ flex?: number; gap?: string }>`
  display: flex;
  flex: ${props => props.flex ?? 1};
  gap: ${props => props.gap ?? ""};
`;

export default ContentContainer;
